var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.983437 0.800857C0.807181 0.800857 0.628129 0.869294 0.494065 1.00336C0.225937 1.27148 0.225937 1.71445 0.494065 1.9821L5.50779 6.99582C5.63716 7.12519 5.81998 7.19832 5.99716 7.19832C6.17293 7.19832 6.34779 7.13457 6.48653 6.99582L11.4938 1.98858C11.7741 1.72468 11.7778 1.27092 11.5097 1.00327C11.2416 0.735145 10.7986 0.735145 10.531 1.00327L6.0066 5.53651L1.47288 1.00279C1.33882 0.868729 1.15975 0.800293 0.98351 0.800293L0.983437 0.800857Z",
    fill: "#006AC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.01a93bb8320400ded534ee173c4c49ad.svg";
export { ForwardRef as ReactComponent };